module.exports = __webpack_public_path__ + "static/media/VAPOR-BNB.aa55d18f.png";